export function normalizeSsn(value, previousValue) {
  previousValue = previousValue || '';
  value = value || '';
  return value.length > 9 || (/[^\d]/).test(value) ? previousValue : value;
}

export function normalizeSsnLast4Digits(value, previousValue) {
  previousValue = previousValue || '';
  value = value || '';
  return value.length > 4 || (/[^\d]/).test(value) ? previousValue : value;
}



// WEBPACK FOOTER //
// ./src/utils/normalizeSsn.js